import { Hsluv }	from "@v3/data/primitive/hsluv";
import { HexColor }	from "@v3/data/primitive/hexColor";

export type HsluvColor	= {
	// 0..360
	hue:		number,
	// 0..100
	saturation:	number,
	// 0..100
	lightness:	number,
};

export namespace HsluvColor {
	export const toHex	= (it:HsluvColor):HexColor	=> {
		const conv		= new Hsluv();
		conv.hsluv_h	= it.hue;
		conv.hsluv_s	= it.saturation;
		conv.hsluv_l	= it.lightness;
		conv.hsluvToHex();
		return HexColor.brand(conv.hex);
	};
};
